import { NavigationGuard } from 'vue-router';
import store from '@/store';

export const localeGuard: NavigationGuard = async (to, from, next) => {
  if (to.params.lang && to.params.lang !== from.params.lang)
    store.dispatch('app/updateLocale', {
      locale: to.params.lang === 'de' ? 'de-DE' : 'en-GB',
      isInitial: true
    });
  next();
};
